module.exports = __webpack_public_path__ + "static/media/10_tearsofhair.33c466b8.jpg";